// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/App.css
// module id = 1527
// module chunks = 0